import React from "react";

// Footer'da kullandığımız ikonları tekrar import edelim
import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhoneAlt,
  FaRegClock,
} from "react-icons/fa";

// Stil dosyamızı import edelim
import "./ContactMapSection.scss";

// Footer'daki ile aynı olan iletişim bilgileri
const contactData = [
  {
    icon: <FaMapMarkerAlt />,
    text: "Tepekule, 2084/8. Sk. No:31 B, 35000 Bayraklı/İzmir",
  },
  { icon: <FaEnvelope />, text: "vetizmirveterinerklinigi@gmail.com" },
  { icon: <FaPhoneAlt />, text: "+90 538 597 04 41" },
  {
    icon: <FaRegClock />,
    text: "Hafta içi : 09.00 - 19.00 / Cumartesi : 09.00 - 19.00 Pazar :Kapalı",
  },
];

// İletişim Kartı
const ContactCard = () => {
  return (
    <div className="contact-card">
      <h2 className="contact-card__title">İletişim Bilgileri</h2>
      <div className="contact-card__items">
        {contactData.map((item, index) => (
          <div key={index} className="contact-card__item">
            <div className="icon-wrapper">{item.icon}</div>
            <span>{item.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

// Ana Component
const ContactMapSection = () => {
  return (
    <section className="contact-map-section">
      {/* İletişim Kartı, haritanın üstünde duracak */}
      <ContactCard />

      {/* Google Haritası */}
      <div className="map-container">
        {/* BU IFRAME KODUNU KENDİ ADRESİNİZLE DEĞİŞTİRECEKSİNİZ */}
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3123.990730611453!2d27.178405500000004!3d38.46477530000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14b97d4dc4df0e21%3A0x241ec15ce7c78030!2sVet-%20%C4%B0zmir%20Veteriner%20Klini%C4%9Fi!5e0!3m2!1str!2str!4v1752917861726!5m2!1str!2str"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Klinik Adresi"
        ></iframe>
      </div>
    </section>
  );
};

export default ContactMapSection;
